// extracted by mini-css-extract-plugin
export default {"box":"card_box__PXRlh"};